<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
  <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub2}}</h1>
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub3}}</h1>
  <div class="col-sm-12">
    <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8">
      <div class="col-3 q-cards pl-1 pr-1">
        <label class="card card-list pt-2 text-center d-inline-block pull-right" for="small_commercial">
          Small Commercial
          <img src="{{small_src}}" class="comimg mt-2">
          <div></div>
          <label for="small_commercial" class="lnhgtnor">Under $2K <br>per month</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
            <input type='checkbox' class="custom-control-input" id="small_commercial" value='Under $2K per month'
              [(ngModel)]="hgAverageBills.small" name="average_bill" (change)="getAverageBills($event)" />
            <label class="custom-control-label" for="small_commercial"></label>
          </div>
        </label>
      </div>
      <div class="col-3 q-cards pl-1 pr-1">
        <label class="card card-list pt-2 text-center d-inline-block pull-left" for="meduim_commercial">
          Medium Commercial
          <img src="{{medium_src}}" class="comimg mt-2">
          <div></div>
          <label for="meduim_commercial" class="lnhgtnor">$2K - $10K <br>per month</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
            <input type='checkbox' class="custom-control-input" id="meduim_commercial" value='$2K - $10K per month'
              [(ngModel)]="hgAverageBills.medium" name="average_bill" (change)="getAverageBills($event)" />
            <label class="custom-control-label" for="meduim_commercial"></label>
          </div>
        </label>
      </div>
      <div class="col-3 q-cards pl-1 pr-1">
        <label class="card card-list pt-2 text-center d-inline-block pull-left" for="large_commercial">
          Large Commercial
          <img src="{{large_src}}" class="comimg mt-4">
          <div></div>
          <label for="large_commercial" class="mt-2 lnhgtnor">$10K - $20K <br>per month</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
            <input type='checkbox' class="custom-control-input" id="large_commercial" value='$10K - $20K per month'
              [(ngModel)]="hgAverageBills.large" name="average_bill" (change)="getAverageBills($event)" />
            <label class="custom-control-label" for="large_commercial"></label>
          </div>
        </label>
      </div>
      <div class="col-3 q-cards pl-1 pr-1">
        <label class="card card-list pt-2 text-center d-inline-block pull-left" for="industrial">
            Industrial
          <img src="{{industrial_src}}" class="comimg mt-4">
          <div></div>
          <label for="industrial" class="mt-2 lnhgtnor">Over $20K <br>per month</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
            <input type='checkbox' class="custom-control-input" id="industrial" value='Over $20K per month'
              [(ngModel)]="hgAverageBills.industrial" name="average_bill" (change)="getAverageBills($event)" />
            <label class="custom-control-label" for="industrial"></label>
          </div>
        </label>
      </div>
    </div>
  </div>
  <button *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'combtn': isChecked}"
    (click)="next();">Next</button>
</div>
<div class="container mobileview px-0 mb-3" [attr.id]="questionObj._id" style="float:left;">
    <div class="d-flex h-100 row col-sm-12 pr-0" style="margin-top: 2.5rem!important;">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left">{{question}}</h1>
        </div>
      </div>
    </div>
    <div class="row col-sm-12 m-auto">
     
        <div class="col-6 q-cards pl-0 box-shadow-none">
            <label class="card card-list text-center" for="small_commercial" style="min-height: 156px;">
                Small Commercial
                <img width="50%" class='mx-auto' src="{{small_src}}">
                <div><label for="small_commercial" class="lnhgtnor">Under $2K <br>per month</label></div>
                <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                  <input type='checkbox' class="custom-control-input" id="small_commercial_mob" value='Under $2K per month'
                    [(ngModel)]="hgAverageBills.small" name="average_bill" (change)="getAverageBills($event)" />
                  <label class="custom-control-label" for="small_commercial"></label>
                </div>
              </label>
        </div>
        <div class="col-6 q-cards pr-0 box-shadow-none">
            <label class="card card-list text-center" for="meduim_commercial" style="min-height: 156px;">
                Medium Commercial
                <img height="50%" class='mx-auto' src="{{medium_src}}">
                <div style=""><label for="meduim_commercial" class="lnhgtnor">$2K - $10K <br>per month</label></div>
                <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                  <input type='checkbox' class="custom-control-input" id="meduim_commercial_mob" value='$2K - $10K per month'
                    [(ngModel)]="hgAverageBills.medium" name="average_bill" (change)="getAverageBills($event)" />
                  <label class="custom-control-label" for="meduim_commercial"></label>
                </div>
              </label>
              <!-- <label class="card card-list text-center d-inline-block" for="small_commercial" style="min-height: 156px;">
                Small Commercial
                <img src="{{small_src}}">
                <div><label for="small_commercial" class="lnhgtnor">Under $2K <br>per month</label></div>
                <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                  <input type='checkbox' class="custom-control-input" id="small_commercial_mob" value='Under $2K per month'
                    [(ngModel)]="hgAverageBills.small" name="average_bill" (change)="getAverageBills($event)" />
                  <label class="custom-control-label" for="small_commercial"></label>
                </div>
              </label> -->
        </div>
     
     
          <div class="col-6 q-cards pl-0 box-shadow-none">
              <label class="card card-list text-center" for="large_commercial">
                  Large Commercial
                  <img class='mx-auto' src="{{large_src}}">
                  <div><label for="large_commercial" class="mt-2 lnhgtnor">$10K - $20K <br>per month</label></div>
                  <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                    <input type='checkbox' class="custom-control-input" id="large_commercial_mob" value='$10K - $20K per month'
                      [(ngModel)]="hgAverageBills.large" name="average_bill" (change)="getAverageBills($event)" />
                    <label class="custom-control-label" for="large_commercial"></label>
                  </div>
                </label>
          </div>
          <div class="col-6 q-cards pr-0 box-shadow-none">
              <label class="card card-list text-center" for="industrial">
                  <div>Industrial</div>
                <img class='mx-auto' src="{{industrial_src}}">
                <div><label for="industrial" class="mt-2 lnhgtnor">Over $20K <br>per month</label></div>
                <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                  <input type='checkbox' class="custom-control-input" id="industrial_mob" value='Over $20K per month'
                    [(ngModel)]="hgAverageBills.industrial" name="average_bill" (change)="getAverageBills($event)" />
                  <label class="custom-control-label" for="industrial"></label>
                </div>
              </label>
          </div>
       
      <div class="mb-3" style="width:100% !important; text-align: right;">
        <div *ngIf="user_bot" class="ash_box mt-2">
          <h1 class="ansMob">{{avg_bill}}</h1>
        </div>
      </div>
    </div>
    <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
          <img style="width:100%;" src="assets/images/logo-charcoal.png" />
      </div>
      <div class="col-sm-2 col-2 px-0 my-auto">
          <div class="arrow_box">
              <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
          </div>
      </div>
    </div>
  </div>